import { init }  from '@amplitude/analytics-browser';
import { track } from '@amplitude/analytics-browser';
import { flush } from '@amplitude/analytics-browser';
import { identify, Identify } from '@amplitude/analytics-browser';
import { setOptOut } from '@amplitude/analytics-browser';
import { getCookieConsent } from '../helpers';

export default class amplitude {
    
    constructor(){
    }  

    //initialise amplitude api with key, user_id and custom configuration to allow events to be sent
    initialiseAmplitude(apiKey, disableCookies = true, amplitudeOptOut = true){
        init(apiKey, null, {
            defaultTracking: {
                pageViews: true,
                sessions: true,
            },
            cookieSecure: true,
            disableCookies: disableCookies,
            optOut: amplitudeOptOut,
            serverZone: 'EU',
        });
    }

    //function for handling form_submission events
    formSubmissionEvent(product, status, journey){
        const eventProperties = {
            product: product,
            status: status,
            journey: journey
        };
        this.fireEvent('form_submission', eventProperties);
    }

    //function for handling form_interaction events
    formInteractionEvent(fieldName, validationStatus, errorMessages = '', formType = ''){
        const eventProperties = {
            field_name: fieldName,
            validation: validationStatus,
            error: errorMessages,
            formType: formType

        };
        this.fireEvent('form_interaction', eventProperties);
    }

    //function for handling term_interaction events
    termInteractionEvent(termLength){
        const eventProperties = {
            term: termLength,
        };
        this.fireEvent('term_interaction', eventProperties);
    }

    //function for handling form_consent events
    formConsentEvent(consentType, consentAction){
        const eventProperties = {
            consent_type: consentType,
            consent_action: consentAction
        };
        this.fireEvent('form_consent', eventProperties);
    }

    //function for handling cta_interaction events
    //  section: page section cta was initiated
    //  buttonText: text of the button that was clicked
    //  buttonUrl: url of the page the button was clicked on
    //  targetUrl: target url for the button click event
    //  buttonColor: hex colour of the clicked button
    buttonClickEvent(section, buttonText, buttonUrl, targetUrl, buttonColor){
        const eventProperties = {
            section: section,
            button_text: buttonText,
            button_url : buttonUrl,
            target_url: targetUrl,
            button_color: buttonColor
        };
        this.fireEvent('cta_interaction', eventProperties);
    }

    //function for handling product_details events
    productDetailsEvent(cashWithdrawal){
        const eventProperties = {
            cash_withdrawal: cashWithdrawal == 'true' ? "yes" : "no",
        };
        this.fireEvent('product_details', eventProperties);
    }

    //function for handling slider loan amount events
    sliderInteraction(sliderValue){
        const eventProperties = {
            slider_loan_amount: sliderValue,
        };
        this.fireEvent('loan_slider_interaction', eventProperties);
    }

    //function for handling loans sticky header edit button click events
    loanHeaderEditEvent(){
        this.fireEvent('loan_header_edit');
    }

    //function for handling form_application_response
    formApplicationResponse(eventProperties){
        this.fireEvent('form_application_response', eventProperties);
    }

    //function for handling faq_link click for vulnerable customer signposting
    faqLinkClick(signpostText = 'unknown', target = 'unknown'){
        const eventProperties = {
            signpost_text: signpostText,
            target_question: target
        };
        this.fireEvent('vulnerable_signpost_faq_click', eventProperties);        
    }

    //function for handling faq_interaction
    faqInteraction(faqText = 'unknown', action= 'unknown'){
        const eventProperties = {
            faq_question: faqText,
            action: action
        };
        this.fireEvent('faq_interaction', eventProperties);
    }

    //function for tracking debt advice link click on thimbl card loans downsell
    debtAdviceClick() {
        const eventProperties = {
            action: 'clicked',
        };
        this.fireEvent('downsell_debt_advice_click', eventProperties);
    }

    //function for tracking stepchange clickouts on thimbl card loans downsell
    stepchangeClickout() {
        const eventProperties = {
            action: 'clicked',
        };
        this.fireEvent('downsell_stepchange_clickout', eventProperties);
    }

    //function for tracking moneyhelper clickouts on thimbl card loans downsell
    moneyhelperClickout() {
        const eventProperties = {
            action: 'clicked',
        };
        this.fireEvent('downsell_moneyhelper_clickout', eventProperties);
    }
    
    //function used to set user properties
    applyUserProperties(userProperties){
        if (getCookieConsent() != 'true') {
            return;
        }

        const userIdentity = new Identify();

        Object.keys(userProperties).forEach(key => {
            userIdentity.set(key, userProperties[key]);
        });
        return identify(userIdentity);
    }

    //if cookie consent is true fire event, this is required as first time customers will not have setOptOut value
    //instead the fireEvent method will only fire events if the cookie value for consent is true or it will not fire
    fireEvent(eventName, eventProperties){
        if (getCookieConsent() === 'true') {
            track(eventName, eventProperties);
        }
    }

    //function for sending stored events immediately
    flushEvents(){
        flush();
    }

}